// One game's board on the club leaderboard page: top five with a "view all"
// link, or every score when fullBoard is set. Each row opens that game's
// shared page (/game/:userGameId).
import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';

import Avatar from '../common/Avatar';

const PREVIEW_ROWS = 5;
const SIGNAGE_ROWS = 8;
const PLACE_COLORS = ['#F5C84B', '#C9CED6', '#D08B57']; // gold, silver, bronze

// userName is the JSON the app posts ({displayName, photoURL, ...}); very old
// rows hold a bare name.
function parseUser(userName) {
  try {
    const u = JSON.parse(userName);
    if (u && typeof u === 'object') return u;
  } catch (e) { /* bare string */ }
  return { displayName: userName ? String(userName) : 'Guest' };
}

export default function LeaderboardCard({ leaderboard, fullBoard, signage, onSelect, onBack }) {

  const lb = leaderboard.leaderboard;
  const scores = leaderboard.scores || [];
  const limit = fullBoard ? scores.length : (signage ? SIGNAGE_ROWS : PREVIEW_ROWS);
  const shown = scores.slice(0, limit);
  const plays = lb.plays || scores.length;

  const renderRow = (score, index) => {
    const user = parseUser(score.userName);
    const name = user.displayName || 'Guest';
    const placeColor = PLACE_COLORS[index];

    const row = (
      <>
        <div className="lbPlace" style={placeColor ? { color: placeColor } : null}>{index + 1}</div>
        <Avatar displayName={name} photoURL={user.photoURL} size={signage ? 44 : 36} />
        <div className="lbWho">
          <div className="lbName ellipsis">{name}</div>
          <div className="lbWhen">
            {moment(score.created_at).fromNow()}
            {score.distance > 0 ? ' · ' + score.distance + ' ft' : ''}
          </div>
        </div>
        <div className="lbScore" style={placeColor ? { color: placeColor } : null}>{score.score}</div>
      </>
    );

    if (signage || !score.userGameId || score.userGameId == 0) {
      return <div key={score.id || index} className="lbRow">{row}</div>;
    }
    return <Link key={score.id || index} to={'/game/' + score.userGameId} className="lbRow lbRowLink">{row}</Link>;
  };

  return (
    <div className="gcard lbCard">

      <div className="hrowBetween">
        <div style={{ minWidth: 0 }}>
          <div className="gameTitle ellipsis">{lb.title}</div>
          <div className="timeAgo">
            {plays} {plays == 1 ? 'score' : 'scores'}
            {lb.order === 'asc' ? ' · lowest score wins' : ''}
          </div>
        </div>
        {onBack ? <button className="btnGhost lbSmallBtn" onClick={onBack}>All games</button> : null}
      </div>

      <div className="lbRows">
        {shown.map(renderRow)}
      </div>

      {!fullBoard && onSelect && scores.length > limit ? (
        <button className="btnGhost lbMore" onClick={onSelect}>View all {scores.length}{plays > scores.length ? ' top' : ''} scores</button>
      ) : null}

    </div>
  );

}
